import React, { VFC } from 'react';
import { CellProps } from 'react-table';

export const PublishingCell: VFC<CellProps<any>> = ({ cell }) => {
  return <span>{cell.value ? '公開' : '非公開'}</span>;
};
